<template>
  <!--------------------------------------
    Grid element to contain a few data points for congressional profiles -- long flex row. Fill with <ProfileDataPoint> elements.
  ---------------------------------------->
  <div class="profile-data-row lsc-dot-gov-styling" :class="'cols-when-wide-' + String(columnsWhenWide)">
    <div class="icon-and-title">
      <div class="element-icon" v-if="icon">
        <v-icon color="#fff" size="45">
          {{ icons[icon] }}
        </v-icon>
      </div>
      <h4 class="element-title">{{ title }}</h4>
    </div>
    <div class="element-contents" :class="classes">
      <slot></slot>
    </div>

  </div>
</template>

<script>
import { mdiAccountMultiple, mdiScaleBalance, mdiHomeVariantOutline, mdiGavel, mdiCurrencyUsd, mdiHandshake } from '@mdi/js';

export default {
  name: 'ProfileDataElement',

  props: {
    title: { type: String, required: false },
    icon: { type: String, required: false },
    shaded: { type: Boolean, required: false, default: true }, // light blue shading and white icon (if true) or vice versa?
    bordered: { type: Boolean, required: false, default: true }, // false makes the border white but it will still be present for the sake of consistent content positioning
    centered: { type: Boolean, required: false, default: false }, // true for centered flex
    columnsWhenWide: { type: String, required: false, default: '1' } // string number
  },

  data () {
    return {
      icons: {
        'people': mdiAccountMultiple,
        'scale': mdiScaleBalance,
        'house': mdiHomeVariantOutline,
        'gavel': mdiGavel,
        'dollar': mdiCurrencyUsd,
        'handshake': mdiHandshake
      }
    }
  },

  computed: {
    classes() {
      let c = []
      c[0] = this.shaded === true ? 'shaded' : 'not-shaded'
      c[1] = this.bordered === true ? 'bordered' : 'not-bordered'
      c[2] = this.centered === true ? 'centered' : 'not-centered'
      return c.join(' ')
    }
  }
}
</script>

<style lang="scss">
@import '@/scss/vars.scss';
@import '@/scss/lsc-dot-gov.scss';

.profile-data-row {
  padding: 0.5rem 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;

  .icon-and-title {
    display: flex;
    align-items: center;
    margin-right: 1rem;
    max-width: 20rem;    
    min-width: 20rem; 
  }

  .element-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1rem;
    border-radius: 50%;
    height: auto;
    width: auto;
    padding: 0.5rem;
    background-color: #B10000;
  }
  .element-title {
    width: 16rem;
    font-style: normal;
  }
  .element-contents {
    border-radius: 0.5rem;
    box-sizing: border-box;
    // box-shadow: rgb(17 17 26 / 2%) 2px 2px 2px;
    display: flex;
    padding: 0.75rem 0.5rem;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    flex-grow: 1;
    font-size: 1.25rem;

    >div {
      width: 100%;
    }
  
    &.shaded {
      background-color: $polar;
    }
    &.bordered {
      border-right: 0.1rem solid rgba($main-blue, 0.2);
      border-bottom: 0.1rem solid rgba($main-blue, 0.2);
    }
    &.not-bordered {
      border: 0.4rem solid #fff;
    }
    &.centered {
      justify-content: center;
    }
  }
  .profile-data-point {
    padding: 0.5rem 1.25rem;
    margin: 0.25rem;
  }
  &.cols-when-wide-2 {
    .profile-data-point {
      max-width: 45%;
    }
  }
  &.cols-when-wide-3 {
    .profile-data-point {
      max-width: 30%;
    }
  }
}

@media screen and (max-width: 1000px) {
  .profile-data-row {
    flex-wrap: wrap;
    
    .icon-and-title, .element-title {
      max-width: 100%;
      width: 100%;
    }
    .element-icon {
      margin-left: 0;
    }
    .element-contents {
      width: 100%;
    }
    .profile-data-point {
      max-width: none;
    }
    &.cols-when-wide-2 {
      .profile-data-point {
        max-width: none;
      }
    }
    &.cols-when-wide-3 {
      .profile-data-point {
        max-width: none;
      }
    }
  }
}

</style>